/**
 * The selected row lives in the URL beside the search and status filters,
 * so a link opens the page with the panel already showing.
 */
const KEY = 'selected'

export function readSelectedTag(params: URLSearchParams): string | null {
    const value = params.get(KEY)
    return value ? value : null
}

/** A copy of `params` with the selection set, or cleared when `tag` is null. */
export function withSelectedTag(params: URLSearchParams, tag: string | null): URLSearchParams {
    const next = new URLSearchParams(params)
    if (tag) {
        next.set(KEY, tag)
    } else {
        next.delete(KEY)
    }
    return next
}
